export default function () {
    function buildReactiveHead(video, error) {
        watch(
            video,
            () => {
                buildHead(video.value, error.value);
            },
            {immediate: true},
        );
    }

    function buildHead(video, error) {
        if (video === null && !error) return useSeo().buildHeadLoading();
        if (!video) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            type: 'video',
            image: video.video_image_url || null,
            title: video.video_title_full,
            description: video.video_description,
            structuredData: useSchemaVideo().build(video),
            index: true,
        });
    }

    return {buildReactiveHead};
}
